import * as Sentry from '@sentry/react'
import {useCallback} from 'react'
import {useUserContext} from '@goschool/auth'

export function useSentry() {
  const {user} = useUserContext()

  return useCallback(
    (error: unknown) => {
      const payload = {
        user: {id: user?.uid, email: user?.email ?? undefined},
        extra: {
          href: window.location.href
        }
      }

      Sentry.captureException(
        error,
        payload
      )
    }, [user]
  )
}
